<div class="black-background animated fadeIn fast" [hidden]="_modal.hidden">
  <div class="modal" style="display: block" tabindex="-1" role="dialog">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              (click)="hide()"
              class="close"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <app-new-receipt
            *ngIf="_modal.getOperation() === 'CREATE'"
            [events]="closeEvents.asObservable()"
          ></app-new-receipt>
          <app-receipt-detail
            *ngIf="_modal.getOperation() === 'SHOW'"
            [events]="closeEvents.asObservable()"
          ></app-receipt-detail>
          <app-edit-receipt
            *ngIf="_modal.getOperation() === 'EDIT'"
            [receipt]="_modal.receipt"
            [events]="closeEvents.asObservable()"
          ></app-edit-receipt>
        </div>
      </div>
    </div>
  </div>
</div>
